// AR Practice Data
// Structured for Supabase migration with multi-language support
// Based on the reference image showing AR Real-world Practice features

export const arPracticeData = {
  // Page Overview
  overview: {
    id: "ar_practice",
    title: {
      tc: "AR 實境練習",
      sc: "AR 实境练习",
      en: "AR Real-world Practice"
    },
    subtitle: {
      tc: "透過擴增實境技術進行真實情境練習",
      sc: "通过增强现实技术进行真实情境练习",
      en: "Practice in real-world scenarios through augmented reality technology"
    }
  },

  // AR Mode Activation Section
  activationSection: {
    id: "ar_activation",
    title: {
      tc: "啟動 AR 模式",
      sc: "启动 AR 模式",
      en: "Activate AR Mode"
    },
    description: {
      tc: "將鏡頭對準周圍環境開始練習",
      sc: "将镜头对准周围环境开始练习",
      en: "Point the camera at the surrounding environment to start practicing"
    },
    buttonText: {
      tc: "開始掃描",
      sc: "开始扫描",
      en: "Start Scanning"
    },
    cameraIcon: "📷",
    activationStatus: "ready" // ready, scanning, active, error
  },

  // AR Scene Selection Section
  sceneSelection: {
    id: "scene_selection",
    title: {
      tc: "AR 場景選擇",
      sc: "AR 场景选择",
      en: "AR Scene Selection"
    },
    scenes: [
      {
        id: "shopping_scene",
        icon: "🏪",
        iconText: "24H",
        title: {
          tc: "商店購物",
          sc: "商店购物",
          en: "Store Shopping"
        },
        description: {
          tc: "練習購物對話",
          sc: "练习购物对话",
          en: "Practice shopping dialogue"
        },
        difficulty: "beginner",
        estimatedDuration: {
          tc: "5-10 分鐘",
          sc: "5-10 分钟",
          en: "5-10 minutes"
        },
        vocabulary: [
          { tc: "商品", sc: "商品", en: "product" },
          { tc: "價格", sc: "价格", en: "price" },
          { tc: "折扣", sc: "折扣", en: "discount" },
          { tc: "收銀台", sc: "收银台", en: "cash register" }
        ],
        phrases: [
          { tc: "這個多少錢？", sc: "这个多少钱？", en: "How much is this?" },
          { tc: "有折扣嗎？", sc: "有折扣吗？", en: "Is there a discount?" },
          { tc: "我要買這個", sc: "我要买这个", en: "I want to buy this" }
        ],
        isUnlocked: true,
        isCompleted: false,
        progress: 0
      },
      {
        id: "restaurant_scene",
        icon: "🍽️",
        iconText: "",
        title: {
          tc: "餐廳點餐",
          sc: "餐厅点餐",
          en: "Restaurant Ordering"
        },
        description: {
          tc: "學習點餐用語",
          sc: "学习点餐用语",
          en: "Learn ordering phrases"
        },
        difficulty: "beginner",
        estimatedDuration: {
          tc: "8-12 分鐘",
          sc: "8-12 分钟",
          en: "8-12 minutes"
        },
        vocabulary: [
          { tc: "菜單", sc: "菜单", en: "menu" },
          { tc: "主菜", sc: "主菜", en: "main course" },
          { tc: "甜點", sc: "甜点", en: "dessert" },
          { tc: "飲料", sc: "饮料", en: "beverage" }
        ],
        phrases: [
          { tc: "請給我菜單", sc: "请给我菜单", en: "Please give me the menu" },
          { tc: "我要點這個", sc: "我要点这个", en: "I want to order this" },
          { tc: "謝謝，很好吃", sc: "谢谢，很好吃", en: "Thank you, it's delicious" }
        ],
        isUnlocked: true,
        isCompleted: false,
        progress: 0
      },
      {
        id: "office_scene",
        icon: "🏢",
        iconText: "",
        title: {
          tc: "辦公室會議",
          sc: "办公室会议",
          en: "Office Meeting"
        },
        description: {
          tc: "商務對話練習",
          sc: "商务对话练习",
          en: "Business dialogue practice"
        },
        difficulty: "intermediate",
        estimatedDuration: {
          tc: "10-15 分鐘",
          sc: "10-15 分钟",
          en: "10-15 minutes"
        },
        vocabulary: [
          { tc: "會議", sc: "会议", en: "meeting" },
          { tc: "報告", sc: "报告", en: "report" },
          { tc: "提案", sc: "提案", en: "proposal" },
          { tc: "討論", sc: "讨论", en: "discussion" }
        ],
        phrases: [
          { tc: "我們開始會議吧", sc: "我们开始会议吧", en: "Let's start the meeting" },
          { tc: "我有個提案", sc: "我有个提案", en: "I have a proposal" },
          { tc: "大家有什麼意見？", sc: "大家有什么意见？", en: "Does anyone have any opinions?" }
        ],
        isUnlocked: false,
        isCompleted: false,
        progress: 0
      },
      {
        id: "airport_scene",
        icon: "✈️",
        iconText: "",
        title: {
          tc: "機場旅行",
          sc: "机场旅行",
          en: "Airport Travel"
        },
        description: {
          tc: "旅遊英語對話",
          sc: "旅游英语对话",
          en: "Travel English dialogue"
        },
        difficulty: "intermediate",
        estimatedDuration: {
          tc: "12-18 分鐘",
          sc: "12-18 分钟",
          en: "12-18 minutes"
        },
        vocabulary: [
          { tc: "登機證", sc: "登机证", en: "boarding pass" },
          { tc: "行李", sc: "行李", en: "luggage" },
          { tc: "海關", sc: "海关", en: "customs" },
          { tc: "護照", sc: "护照", en: "passport" }
        ],
        phrases: [
          { tc: "我要辦理登機", sc: "我要办理登机", en: "I want to check in" },
          { tc: "我的行李在哪裡？", sc: "我的行李在哪里？", en: "Where is my luggage?" },
          { tc: "這是我的護照", sc: "这是我的护照", en: "This is my passport" }
        ],
        isUnlocked: false,
        isCompleted: false,
        progress: 0
      }
    ]
  },

  // AR Feature Highlights Section
  featureHighlights: {
    id: "feature_highlights",
    title: {
      tc: "AR 功能特色",
      sc: "AR 功能特色",
      en: "AR Feature Highlights"
    },
    features: [
      {
        id: "facial_recognition",
        icon: "👁️",
        iconColor: "blue",
        title: {
          tc: "表情識別",
          sc: "表情识别",
          en: "Facial Recognition"
        },
        description: {
          tc: "AI 分析你的表情和肢體語言",
          sc: "AI 分析你的表情和肢体语言",
          en: "AI analyzes your facial expressions and body language"
        },
        isEnabled: true,
        accuracy: 95
      },
      {
        id: "3d_sound_effects",
        icon: "🔊",
        iconColor: "purple",
        title: {
          tc: "3D 音效",
          sc: "3D 音效",
          en: "3D Sound Effects"
        },
        description: {
          tc: "立體聲音效增強沉浸感",
          sc: "立体声音效增强沉浸感",
          en: "Stereo sound effects enhance immersion"
        },
        isEnabled: true,
        quality: "high"
      },
      {
        id: "interactive_objects",
        icon: "🎯",
        iconColor: "green",
        title: {
          tc: "互動物件",
          sc: "互动物件",
          en: "Interactive Objects"
        },
        description: {
          tc: "與虛擬物件進行真實互動",
          sc: "与虚拟物件进行真实互动",
          en: "Real interaction with virtual objects"
        },
        isEnabled: true,
        responsiveness: "excellent"
      }
    ]
  },

  // Navigation and UI Elements
  navigation: {
    backButton: {
      tc: "返回",
      sc: "返回",
      en: "Back"
    },
    startScanningButton: {
      tc: "開始掃描",
      sc: "开始扫描",
      en: "Start Scanning"
    },
    selectSceneButton: {
      tc: "選擇場景",
      sc: "选择场景",
      en: "Select Scene"
    }
  },

  // Status Messages
  statusMessages: {
    scanning: {
      tc: "掃描中...",
      sc: "扫描中...",
      en: "Scanning..."
    },
    sceneDetected: {
      tc: "場景已識別",
      sc: "场景已识别",
      en: "Scene Detected"
    },
    readyToStart: {
      tc: "準備開始",
      sc: "准备开始",
      en: "Ready to Start"
    },
    errorOccurred: {
      tc: "發生錯誤",
      sc: "发生错误",
      en: "Error Occurred"
    }
  },

  // Progress Tracking
  progressTracking: {
    overallProgress: {
      tc: "整體進度",
      sc: "整体进度",
      en: "Overall Progress"
    },
    sceneProgress: {
      tc: "場景進度",
      sc: "场景进度",
      en: "Scene Progress"
    },
    accuracyScore: {
      tc: "準確度分數",
      sc: "准确度分数",
      en: "Accuracy Score"
    }
  }
};

// Helper functions for AR practice management
export const getSceneById = (sceneId) => {
  return arPracticeData.sceneSelection.scenes.find(scene => scene.id === sceneId);
};

export const getScenesByDifficulty = (difficulty) => {
  return arPracticeData.sceneSelection.scenes.filter(scene => scene.difficulty === difficulty);
};

export const getUnlockedScenes = () => {
  return arPracticeData.sceneSelection.scenes.filter(scene => scene.isUnlocked);
};

export const updateSceneProgress = (sceneId, progress) => {
  const scene = getSceneById(sceneId);
  if (scene) {
    scene.progress = progress;
    if (progress >= 100) {
      scene.isCompleted = true;
      // Unlock next scene if available
      unlockNextScene(sceneId);
    }
  }
};

export const unlockNextScene = (currentSceneId) => {
  const scenes = arPracticeData.sceneSelection.scenes;
  const currentIndex = scenes.findIndex(scene => scene.id === currentSceneId);
  const nextScene = scenes[currentIndex + 1];
  
  if (nextScene && !nextScene.isUnlocked) {
    nextScene.isUnlocked = true;
  }
};

export const getOverallProgress = () => {
  const scenes = arPracticeData.sceneSelection.scenes;
  const totalProgress = scenes.reduce((sum, scene) => sum + scene.progress, 0);
  return Math.round(totalProgress / scenes.length);
};

export const getCompletedScenes = () => {
  return arPracticeData.sceneSelection.scenes.filter(scene => scene.isCompleted);
};

export const getFeatureById = (featureId) => {
  return arPracticeData.featureHighlights.features.find(feature => feature.id === featureId);
};

export const toggleFeature = (featureId) => {
  const feature = getFeatureById(featureId);
  if (feature) {
    feature.isEnabled = !feature.isEnabled;
  }
};

export const startARSession = (sceneId) => {
  const scene = getSceneById(sceneId);
  if (scene && scene.isUnlocked) {
    // Initialize AR session
    console.log(`Starting AR session for scene: ${sceneId}`);
    return {
      success: true,
      scene: scene,
      sessionId: `ar_session_${Date.now()}`
    };
  }
  return {
    success: false,
    error: "Scene not unlocked or not found"
  };
};

export const endARSession = (sessionId) => {
  // End AR session and save progress
  console.log(`Ending AR session: ${sessionId}`);
  return {
    success: true,
    sessionId: sessionId
  };
};
